module.exports = __webpack_public_path__ + "static/media/Payroll.3845be3a.svg";